(() => {
  const modalClass = 'elkline-quickbuy-modal';
  const closingClass = 'elkline-quickbuy-closing';
  const loadingClass = 'elkline-quickbuy-loading';
  const rootClass = 'elkline-quickbuy-open';
  let activeToggle = null;

  const slugify = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const getContainer = (event) => {
    if (event.target && event.target.classList && event.target.classList.contains('quickbuy-container')) {
      return event.target;
    }
    return event.target && event.target.closest ? event.target.closest('.quickbuy-container') : null;
  };

  const markClosing = (container) => {
    if (container) container.classList.add(closingClass);
  };

  const clearContainer = (container) => {
    container?.querySelectorAll('.quickbuy-content').forEach((content) => {
      if (content.elklineSaleBadgeObserver) content.elklineSaleBadgeObserver.disconnect();
    });
    const inner = container && container.querySelector('.inner');
    if (inner) inner.replaceChildren();
  };

  const getProductBlock = (container) => {
    if (!container) return null;
    return container.elklineProductBlock || container.closest('.product-block');
  };

  const resetProductBlockHeight = (container) => {
    if (!container) return;

    const quickBuy = window.theme && window.theme.quickBuy;
    if (quickBuy && quickBuy.quickbuyResizeObserver) {
      quickBuy.quickbuyResizeObserver.disconnect();
    }
    if (quickBuy && quickBuy.debouncedQuickbuyResizeTimeoutID) {
      window.clearTimeout(quickBuy.debouncedQuickbuyResizeTimeoutID);
    }

    const productBlock = getProductBlock(container);
    if (productBlock) {
      productBlock.classList.remove('expanded');
      productBlock.style.removeProperty('padding-bottom');
      productBlock.style.removeProperty('transition-duration');
    }
    container.style.removeProperty('height');
    container.style.removeProperty('transition-duration');
  };

  const restoreContainer = (container) => {
    if (!container) return;
    const productBlock = getProductBlock(container);
    if (productBlock && productBlock.isConnected) {
      productBlock.appendChild(container);
    } else {
      container.remove();
    }
  };

  const closeModal = (container) => {
    if (!container) return;
    markClosing(container);
    container.classList.remove(loadingClass);
    container.classList.remove(modalClass);
    container.setAttribute('aria-hidden', 'true');
    container.removeAttribute('role');
    container.removeAttribute('aria-modal');
    container.removeAttribute('aria-label');
    resetProductBlockHeight(container);
    clearContainer(container);
    window.setTimeout(() => {
      resetProductBlockHeight(container);
      restoreContainer(container);
      container.classList.remove(closingClass);
      if (!document.querySelector('.quickbuy-container.' + modalClass)) {
        document.documentElement.classList.remove(rootClass);
      }
      if (activeToggle && activeToggle.isConnected) activeToggle.focus();
      activeToggle = null;
    }, 120);
  };

  const createContainer = (productBlock) => {
    if (!productBlock) return null;
    const container = document.createElement('div');
    const colorScheme = productBlock.dataset.elkQuickbuyColorScheme;
    const closeLabel = document.querySelector('.quickbuy-container .close-detail')?.getAttribute('aria-label') || 'Schließen';
    container.className = 'quickbuy-container use-color-scheme js-quickbuy';
    if (colorScheme) container.classList.add('use-color-scheme--' + colorScheme);
    container.innerHTML = '<a href="#" class="close-detail" aria-label="' + closeLabel + '" tabindex="-1" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-x" aria-hidden="true" focusable="false" role="presentation"><path d="M18 6 6 18M6 6l12 12"></path></svg></a><div class="inner"></div>';
    productBlock.appendChild(container);
    return container;
  };

  const getContainerFromToggle = (target) => {
    const toggle = target && target.closest ? target.closest('.quickbuy-toggle') : null;

    // The collection-variant app marks product links with sezerium-url and
    // intercepts their click before Symmetry can open Quick Buy. Keep the
    // already selected variant URL, but hand this button back to the theme.
    if (toggle) toggle.classList.remove('sezerium-url');

    const productBlock = toggle && toggle.closest ? toggle.closest('.product-block') : null;
    if (!productBlock) return null;
    const container = productBlock.querySelector('.quickbuy-container') || createContainer(productBlock);
    if (container) container.elklineProductBlock = productBlock;
    return container;
  };

  const markLoading = (container) => {
    if (!container) return;
    container.classList.remove(closingClass);
    container.classList.add(loadingClass);
    window.setTimeout(() => {
      if (!container.classList.contains(modalClass)) container.classList.remove(loadingClass);
    }, 10000);
  };

  const updateSingleMedia = (container, variant) => {
    const media = container && container.querySelector('[data-elkline-quickbuy-media]');
    const image = media && media.querySelector('img');
    const featuredMedia = variant && (variant.featured_media || variant.featured_image);
    const preview = featuredMedia && (featuredMedia.preview_image || featuredMedia);
    const source = preview && (preview.src || preview.url);
    if (!media || !image || !source) return;

    image.removeAttribute('srcset');
    image.src = source;
    if (preview.width) image.width = preview.width;
    if (preview.height) image.height = preview.height;
    if (featuredMedia.alt) image.alt = featuredMedia.alt;
    if (featuredMedia.id) media.dataset.mediaId = featuredMedia.id;
  };

  const syncVariantMedia = (event) => {
    const container = event.target && event.target.closest
      ? event.target.closest('.quickbuy-container.' + modalClass)
      : null;
    const variant = event.detail && event.detail.variant;
    if (!container || !variant) return;

    window.requestAnimationFrame(() => {
      if (!container.classList.contains(modalClass)) return;
      updateSingleMedia(container, variant);
      normaliseSaleBadges(container, getProductBlock(container));
    });
  };

  const makeSingleMedia = (content) => {
    const gallery = content.querySelector('media-gallery');
    if (!gallery) return;

    const activeSlide = gallery.querySelector('.main-image .slider__item.is-active:not([hidden])')
      || gallery.querySelector('.main-image .slider__item:not([hidden])')
      || gallery.querySelector('.main-image .slider__item');
    const sourceImage = activeSlide && activeSlide.querySelector('img');
    if (!sourceImage) return;

    const singleMedia = document.createElement('div');
    singleMedia.className = 'elkline-quickbuy-media product-column-left';
    singleMedia.dataset.elklineQuickbuyMedia = '';
    if (activeSlide.dataset.mediaId) singleMedia.dataset.mediaId = activeSlide.dataset.mediaId;

    const frame = document.createElement('div');
    frame.className = 'elkline-quickbuy-media__frame';

    const image = sourceImage.cloneNode(true);
    image.classList.add('elkline-quickbuy-media__image');
    image.loading = 'eager';
    image.sizes = '(min-width: 768px) 50vw, 190px';
    frame.appendChild(image);

    const productLabel = gallery.querySelector('.product-label-container');
    if (productLabel) singleMedia.appendChild(productLabel.cloneNode(true));
    singleMedia.appendChild(frame);
    gallery.replaceWith(singleMedia);
  };

  const normaliseSaleBadges = (content, productBlock) => {
    if (!productBlock) return;

    const saleColors = new Set(
      (productBlock.dataset.elkSaleColors || '')
        .split('|')
        .map(slugify)
        .filter(Boolean)
    );

    content.querySelectorAll('.opt-label--swatch[data-swatch]').forEach((swatch) => {
      const colorIsOnSale = saleColors.has(slugify(swatch.dataset.swatch));
      let badge = swatch.querySelector('.elk-swatch-sale');

      if (!colorIsOnSale) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'elk-swatch-sale';
        swatch.appendChild(badge);
      }
      if (badge.textContent !== 'SALE') badge.textContent = 'SALE';
      badge.setAttribute('aria-hidden', 'true');
    });
  };

  const watchSaleBadges = (content, productBlock) => {
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        normaliseSaleBadges(content, productBlock);
      });
    });
    observer.observe(content, { childList: true, subtree: true });
    content.elklineSaleBadgeObserver = observer;
  };

  const prepareQuickBuyContent = (content, productUrl, productBlock) => {
    if (window.theme && window.theme.quickBuy && typeof window.theme.quickBuy.convertToQuickBuyContent === 'function') {
      window.theme.quickBuy.convertToQuickBuyContent(content, productUrl);
    } else {
      content.querySelectorAll('.more, .show-gallery').forEach((link) => {
        link.href = productUrl;
      });
      content.querySelectorAll('.not-in-quickbuy').forEach((element) => element.remove());
      content.querySelectorAll('.only-in-quickbuy').forEach((element) => element.classList.remove('only-in-quickbuy'));
      content.querySelectorAll('.sticky-column-desktop').forEach((element) => element.classList.remove('sticky-column-desktop'));
      content.querySelectorAll('pickup-availability').forEach((element) => element.remove());
      content.querySelectorAll('variant-picker[data-update-url="true"]').forEach((element) => {
        element.dataset.updateUrl = 'false';
      });
      if (window.theme && typeof window.theme.suffixIds === 'function') {
        window.theme.suffixIds(content, 'QuickBuyFallback');
      }
    }

    makeSingleMedia(content);
    normaliseSaleBadges(content, productBlock);
    watchSaleBadges(content, productBlock);
  };

  const loadExternalResources = (page) => {
    page.querySelectorAll(':is(.section-main-product, .section-size-guide) link[rel="stylesheet"]').forEach((link) => {
      const href = link.getAttribute('href');
      if (href && !document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) {
        document.head.insertAdjacentHTML('beforeend', link.outerHTML);
      }
    });
    page.querySelectorAll(':is(.section-main-product, .section-size-guide) script[src]').forEach((script) => {
      const src = script.getAttribute('src');
      if (!src || document.querySelector('script[src="' + src + '"]')) return;
      const resource = document.createElement('script');
      resource.src = src;
      resource.defer = true;
      document.head.appendChild(resource);
    });
  };

  const openFallback = async (toggle, container) => {
    if (!toggle || !container || container.classList.contains(modalClass)) return;

    const inner = container.querySelector('.inner');
    if (!inner) return;

    const productUrl = toggle.href;
    const productBlock = toggle.closest('.product-block');
    activeToggle = toggle;
    container.elklineProductBlock = productBlock;
    document.body.appendChild(container);
    container.classList.remove(closingClass);
    container.classList.add(modalClass);
    container.classList.add(loadingClass);
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.setAttribute('aria-label', toggle.textContent.trim());
    container.removeAttribute('aria-hidden');
    document.documentElement.classList.add(rootClass);
    resetProductBlockHeight(container);

    const closeButton = container.querySelector('.close-detail');
    if (closeButton) {
      closeButton.removeAttribute('tabindex');
      closeButton.removeAttribute('aria-hidden');
      window.requestAnimationFrame(() => closeButton.focus());
    }
    inner.innerHTML = '<div class="loading-spinner"></div>';

    try {
      const response = await fetch(productUrl, { method: 'get' });
      if (!response.ok) throw new Error('Quick Buy konnte nicht geladen werden.');

      const template = document.createElement('template');
      template.innerHTML = await response.text();
      const source = template.content.querySelector('.quickbuy-content');
      if (!source) throw new Error('Quick-Buy-Inhalt fehlt.');

      const content = source.cloneNode(true);
      prepareQuickBuyContent(content, productUrl, productBlock);
      loadExternalResources(template.content);
      inner.replaceChildren(content);
      container.classList.remove(loadingClass);
      container.dispatchEvent(new CustomEvent('on:quickbuy:after-open', { bubbles: true }));
    } catch (error) {
      container.classList.remove(loadingClass);
      const link = document.createElement('a');
      link.className = 'btn btn--primary';
      link.href = productUrl;
      link.textContent = 'Alle Infos zum Artikel';
      inner.replaceChildren(link);
      console.warn(error);
    }
  };

  document.addEventListener('pointerdown', (event) => {
    markLoading(getContainerFromToggle(event.target));
  }, true);

  document.addEventListener('touchmove', (event) => {
    const productImage = event.target && event.target.closest
      ? event.target.closest('product-block .image-cont--with-secondary-image')
      : null;
    if (productImage) event.stopPropagation();
  }, { capture: true, passive: true });

  document.addEventListener('on:quickbuy:before-open', (event) => {
    const container = getContainer(event);
    if (!container) return;
    container.elklineProductBlock = container.closest('.product-block');
    document.body.appendChild(container);
    container.classList.remove(closingClass);
    container.classList.remove(loadingClass);
    container.classList.add(modalClass);
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.removeAttribute('aria-hidden');
    document.documentElement.classList.add(rootClass);
    resetProductBlockHeight(container);
  }, true);

  document.addEventListener('click', (event) => {
    const toggle = event.target && event.target.closest ? event.target.closest('.quickbuy-toggle') : null;
    const toggleContainer = getContainerFromToggle(event.target);
    if (toggle && toggleContainer) {
      event.preventDefault();
      event.stopImmediatePropagation();
      markLoading(toggleContainer);
      openFallback(toggle, toggleContainer);
      return;
    }

    const closeButton = event.target.closest && event.target.closest('.quickbuy-container.' + modalClass + ' .close-detail');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      closeModal(closeButton.closest('.quickbuy-container'));
      return;
    }

    const container = event.target.closest && event.target.closest('.quickbuy-container.' + modalClass);
    if (container && event.target === container) {
      event.preventDefault();
      closeModal(container);
    }
  }, true);

  document.addEventListener('on:quickbuy:after-close', (event) => {
    const container = getContainer(event);
    if (container) closeModal(container);
  }, true);

  document.addEventListener('on:variant:change', syncVariantMedia, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const container = document.querySelector('.quickbuy-container.' + modalClass);
    if (container) closeModal(container);
  });
})();

